import { render, staticRenderFns } from "./TemplateMakerDoc.vue?vue&type=template&id=5e7c1e98&"
import script from "./TemplateMakerDoc.vue?vue&type=script&lang=js&"
export * from "./TemplateMakerDoc.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMakerDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7c1e98')) {
      api.createRecord('5e7c1e98', component.options)
    } else {
      api.reload('5e7c1e98', component.options)
    }
    module.hot.accept("./TemplateMakerDoc.vue?vue&type=template&id=5e7c1e98&", function () {
      api.rerender('5e7c1e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/formioTemplates/vistas/TemplateMakerDoc.vue"
export default component.exports